export const iconsLibrary = {
  lock: "/assets/img/icons/lock-active.svg",
  mail: "/assets/img/icons/mail-default.svg",
  arrowRight: "/assets/img/icons/arrow-right-active.svg",
  arrowRightGreen: "/assets/img/icons/arrow-right-green.svg",
  arrowLeft: "/assets/img/icons/arrow-left-active.svg",
  heartFav: "/assets/img/icons/heart-default.svg",
  shareActive: "/assets/img/icons/share-active.svg",
  arrowLeftBlack: "/assets/img/icons/arrow-left-active-black.svg",
  logoMini: "/assets/img/imgs/cowing-logo.svg",
  landingImage: "/assets/img/imgs/landing.png",
  linkedin: "/assets/img/icons/linkedin.svg",
  email: "/assets/img/icons/email.svg",
  mobileLanding: "/assets/img/imgs/mobile-landing.png",
  photoActive: "/assets/img/icons/camera-active.svg",
  videoActive: "/assets/img/icons/video-active.svg",
  addIcon: "/assets/img/icons/add-circle.svg",
  euroIcon: "/assets/img/icons/euro.svg",
  covidIcon: "/assets/img/icons/covid.svg",
  confirmImg: "/assets/img/imgs/confirm.svg",
  closeSvg: "/assets/img/icons/close-svg.svg",
  employeesSvg: "/assets/img/imgs/img-alta-empleados.svg",
  loadingSvg: "/assets/img/icons/loading-spinner.svg",
  monitorSvg: "/assets/img/icons/monitor-default.svg",
  monitorActiveSvg: "/assets/img/icons/monitor-active.svg",
  monitorActiveGreenSvg: "/assets/img/icons/monitor-active-green.svg",
  usersSvg: "/assets/img/icons/users-default.svg",
  usersActiveSvg: "/assets/img/icons/users-active.svg",
  creditcardSvg: "/assets/img/icons/credit-card-default.svg",
  creditcardActiveSvg: "/assets/img/icons/credit-card-active.svg",
  creditcardActiveGreenSvg: "/assets/img/icons/credit-card-active-green.svg",
  boxSvg: "/assets/img/icons/box-default.svg",
  boxActiveSvg: "/assets/img/icons/box-active.svg",
  boxActiveGreenSvg: "/assets/img/icons/box-active-green.svg",
  calendarSvg: "/assets/img/icons/calendar-default.svg",
  calendarActiveSvg: "/assets/img/icons/calendar-active-mini.svg",
  calendarActiveGreenSvg: "/assets/img/icons/calendar-active-green.svg",
  cowingLogoMenuSvg: "/assets/img/icons/img-logo-menu.svg",
  logoutSvg: "/assets/img/icons/log-out-active.svg",
  notificationsSvg: "/assets/img/icons/24-notifications-bell.svg",
  emailBlue: "/assets/img/icons/email-blue.svg",
  linkedinBlue: "/assets/img/icons/linkedin-blue.svg",
  chevronSvg: "/assets/img/icons/chevron.svg",
  chevronDownSvg: "/assets/img/icons/chevron-down-active.svg",
  infoSvg: "/assets/img/icons/info-icon.svg",
  editSvg: "/assets/img/icons/edit.svg",
  pauseSvg: "/assets/img/icons/pause.svg",
  checkCircle: "/assets/img/imgs/check-circle-active.svg",
  greenUser: "/assets/img/icons/user-active-green.svg",
  explore: "/assets/img/icons/explore.svg",
  exploreActive: "/assets/img/icons/exploreActive.svg",
  fav: "/assets/img/icons/fav.svg",
  favActive: "/assets/img/icons/favActive.svg",
  office: "/assets/img/imgs/office.svg",
  briefcase: "/assets/img/icons/briefcase.svg",
  briefcaseActive: "/assets/img/icons/briefcase-active.svg",
  booking: "/assets/img/icons/booking.svg",
  bookingActive: "/assets/img/icons/bookingActive.svg",
  profile: "/assets/img/icons/profile.svg",
  profileActive: "/assets/img/icons/profileActive.svg",
  map: "/assets/img/icons/map.svg",
  filter: "/assets/img/icons/filter.svg",
  list: "/assets/img/icons/list.svg",
  closeLight: "/assets/img/icons/close-light.svg",
  calendarEmpty: "/assets/img/icons/calendar-active.svg",
  seats: "/assets/img/icons/seats.svg",
  clockActive: "/assets/img/icons/clock-active.svg",
  closeSimple: "/assets/img/icons/ic-actions-close-simple-2.svg",
  confirm: "/assets/img/icons/confirmation.svg",
  leftArrowTable: "/assets/img/icons/left-arrow-table.svg",
  rightArrowTable: "/assets/img/icons/right-arrow-table.svg",
  disabledLeftArrowTable: "/assets/img/icons/disabled-left-arrow-table.svg",
  disabledRightArrowTable: "/assets/img/icons/disabled-right-arrow-table.svg",
  trashActive: "/assets/img/icons/trash-active.svg",
  logOutProfileActive: "/assets/img/icons/log-out-profile-active.svg",
  editBackoffice: "/assets/img/icons/editBackoffice.svg",
  trashBackoffice: "/assets/img/icons/trashBackoffice.svg",
  heart: "/assets/img/imgs/heart.svg",
  locationOff: "/assets/img/icons/location_off.svg",
};
